import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import API from 'api';
import { LoginErrorModel, LoginTaskResponseModel, UTILITY_QUERY } from 'api/utility/utility.model';

export const useFullIdentityLoginTaskQuery = (
  taskId: string,
  options: UseQueryOptions<
    unknown,
    AxiosError<LoginErrorModel>,
    LoginTaskResponseModel,
    UTILITY_QUERY[]
  >
) =>
  useQuery(
    [UTILITY_QUERY.TRACK_TASK_ID],
    () => API.utility.getFullIdentityLoginTask(taskId),
    options
  );
